import React from 'react';
import { Link } from 'react-router-dom';
import usePageMeta from '../utils/usePageMeta';

const NotFound = () => {
  usePageMeta('Page Not Found', null, { noindex: true });

  return (
    <section className="not-found">
      <div className="container">
        <h1>404</h1>
        <p>The page you are looking for does not exist or has been moved.</p>
        <div className="btn-row">
          <Link to="/" className="btn">Back to home</Link>
          <Link to="/contact" className="btn btn-secondary">Contact us</Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
